import React, { useState, useRef } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import ReactFlagsSelect from "react-flags-select";
import { Link, useHistory } from "react-router-dom";

import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import moment from 'moment';

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Edit_user = props => {
  //meta title
  document.title = "Edit User";
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();
  const inputRef = useRef(null)

  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  const [CustomError4, setCustomError4] = React.useState({
		tax_residency: '',
	});

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      country_code: 'ES',
      country: {label: 'Spain', value: 'Spain'},
      tax_id: '',
      date_of_birth: "",
      address: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      address_country: "",
      building: "",
      floor: "",
      zip: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required('First Name is required'),
      last_name: Yup.string()
        .required('Last Name is required'),
      phone: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Mobile Number is required')
        .test(
          'len',
          'Mobile numbers should not be greater than 10 digits!',
          function (value) {
              return value ? value.length <= 10 : false; // Ensure the number is not greater than 10 digits
          }
      ),
      country_code: Yup.string().required('Please select country code'),
      country: Yup.object().shape({
          label: Yup.string().required('Please select a country'),
          value: Yup.string().required('Please select a country'),
        }).required('Please select a country'),
      tax_id: Yup.string()
      .required("Tax Id is required"),
      building: Yup.string()
      .required("Building is required"),
      floor: Yup.string() 
      .required("Floor is required"),
      zip: Yup.string()
      .required("Zip is required"),
      date_of_birth: Yup.date()
              .required("Date of Birth is required")
              .max(
                new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
                "You must be at least 18 years old",
              ),
      address: Yup.string().required(
        "Address is required",
      ),
    }),
    onSubmit: async (values) => {
      if (formData4.tax_residency === null) {
          setCustomError4({
						...CustomError4,
						tax_residency: i18next.t('Profile PG Please select country'),
					});
        } else {
        try {
            setCustomError4({
              ...CustomError4,
              tax_residency: '',
            });
          let temp_country_code = AllCountriesCustomData.find(element => element.code === values.country_code);

          let submit1 = document.getElementById('submit1');
          submit1.disabled = true;
          submit1.textContent = 'Processing...';

          const jsonpar = JSON.stringify({
            u_id: atob(props.match.params.id),
            first_name: values.first_name,
            last_name: values.last_name,
            country: values.country.value,
            country_code: temp_country_code.phone_code,
            phone: values.phone,
            tax_id: values.tax_id,
            building: values.building,
            floor: values.floor,
            zip: values.zip,
            tax_residency: formData4.tax_residency.value,
            date_of_birth: values.date_of_birth,
            address: values.address,
            street: values.street,
            city: values.city,
            state: values.state,
            postal_code: values.postal_code,
            address_country: values.address_country,
          });
          const res = await postRequest('update-user', jsonpar);
          if (res && res.code === 200) {
            history.push({
              pathname: '/user_management',
              state: { code: 200, status: 'success', message: res.message }
            });
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit1.disabled = false;
          submit1.textContent = 'Update';
        } catch (error) {
          console.error("Error : ", error);
        }
      }
    }
  });

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([]);
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesCustomData2(tempArr);

      tempArr = [];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);

      tempArr = [];
      originalText.forEach(element => {
        let temp = {
            code: element.country_code,
            label: element.country_code + ' +' + element.phone_code,
            phone_code: element.phone_code,
        };
        tempArr.push(temp);
      });
      setAllCountriesCustomData(tempArr);

      handleLoadGetUserInfo(originalText);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const handleLoadGetUserInfo = async (TempAllCountriesCustomData) => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-user-info', jsonpar);
    if (res && res.code === 200) {
      let originalText = res.data;
      
      let temp_country_code = TempAllCountriesCustomData.find(element => element.phone_code === originalText.country_code);
        const formattedDate = originalText.date_of_birth
        ? moment(originalText.date_of_birth).format('YYYY-MM-DD')
        : "";

      validation1.setValues({
        ...validation1.values,
        first_name: originalText.first_name,
        last_name: originalText.last_name,
        email: originalText.email,
        country: {label: originalText.country, value: originalText.country},
        phone: originalText.phone,
        country_code: temp_country_code.country_code,
        tax_id: originalText.tax_id,
        building: originalText.building,
        floor: originalText.floor,
        zip: originalText.zip,
        date_of_birth: formattedDate,
        address: originalText.address
      });

      setFormData4({ ...formData4, tax_residency: {label: originalText.tax_residency?originalText.tax_residency:originalText.country, value: originalText.tax_residency?originalText.tax_residency:originalText.country} });

    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/user_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
		}
    else {
      handleLoadGetAllCountries();

      const loadGoogleMapsScript = () => {
        if (!window.google) {
          const script = document.createElement("script")
          script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&libraries=places` // <-- your API key here
          script.async = true
          document.body.appendChild(script)
          script.addEventListener("load", initAutocomplete)
        } else {
          initAutocomplete()
        }
      }

      const initAutocomplete = () => {
        if (inputRef.current) {
          const autocomplete = new window.google.maps.places.Autocomplete(
            inputRef.current,
            { types: ["geocode"] },
          )

          autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace()

            if (!place.address_components) return

            // Extract details from address_components
            let street = "" // Street name
            let city = ""
            let state = "" // Administrative area level 1 (e.g., California)
            let postal_code = ""
            let country = ""
            for (const component of place.address_components) {
              if (component.types.includes("country")) {
                country = component.long_name
              } else if (component.types.includes("postal_code")) {
                postal_code = component.long_name
              } else if (component.types.includes("locality")) {
                city = component.long_name
              } else if (
                component.types.includes("administrative_area_level_1")
              ) {
                state = component.long_name
              } else if (component.types.includes("sublocality")) {
                street = component.long_name
              } else if (component.types.includes("route")) {
                street = component.long_name
              }
            }

            validation1.setFieldValue("address", place.formatted_address || "")
            validation1.setFieldValue("street", street)
            validation1.setFieldValue("city", city)
            validation1.setFieldValue("state", state)
            validation1.setFieldValue("postal_code", postal_code)
            validation1.setFieldValue("address_country", country)
          })
        }
      }

      loadGoogleMapsScript()
      }
  }, []);

  const [formData4, setFormData4] = React.useState({
		tax_residency: {label: 'Spain', value: 'Spain'},
	});

  
  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Edit User")} />
          <Card>
            <CardBody>
              <Row>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">First name :</Label>
                    <Input 
                      name="first_name" 
                      type="text" 
                      placeholder={'Enter first name'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.first_name || ""}
                      invalid={
                        validation1.touched.first_name && validation1.errors.first_name ? true : false
                      }
                    />
                    {validation1.touched.first_name && validation1.errors.first_name ? (
                      <FormFeedback type="invalid">{validation1.errors.first_name}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Last name :</Label>
                    <Input
                      name="last_name" 
                      type="text" 
                      placeholder={'Enter last name'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.last_name || ""}
                      invalid={
                        validation1.touched.last_name && validation1.errors.last_name ? true : false
                      }
                    />
                    {validation1.touched.last_name && validation1.errors.last_name ? (
                      <FormFeedback type="invalid">{validation1.errors.last_name}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Email :</Label>
                    <Input
                      name="email" 
                      type="email" 
                      placeholder={'Enter email'}
                      value={validation1.values.email || ""}
                      readOnly
                    />
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3 Register-Select2">
                    <Label className="form-label">Select country :</Label>
                    <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                    {validation1.touched.country && validation1.errors.country ? (
                      <FormFeedback type="invalid">{validation1.errors.country}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                {/* <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Profile Picture :</Label>
                    <Input type="file" placeholder="" className="fileUpload" id="formFile" />
                  </div>
                </Col> */}
                <Col md={6} xs={12}>
                  <div className="mb-3 signupCountry">
                    <Label>Mobile no. :</Label>
                    <ReactFlagsSelect
                      placeholder={'Select country code'}
                      countries={AllCountriesCustomData.map(country => country.code)}
                      customLabels={AllCountriesCustomData.reduce((acc, country) => {
                        acc[country.code] = country.label;
                        return acc;
                      }, {})}
                      name="country_code" selected={validation1.values.country_code} onSelect={(e) => validation1.setValues({ ...validation1.values, country_code: e })}
                    />
                    <Input
                      name="phone"
                      type="text" 
                      placeholder={'Enter mobile number'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.phone || ""}
                      invalid={
                        validation1.touched.phone && validation1.errors.phone ? true : false
                      }
                    />
                    {validation1.touched.country_code && validation1.errors.country_code ? (
                      <FormFeedback type="invalid">{validation1.errors.country_code}</FormFeedback>
                    ) : null}
                    {validation1.touched.phone && validation1.errors.phone ? (
                      <FormFeedback type="invalid">{validation1.errors.phone}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3">
                    <Label className="form-label">
                      {props.t("Date of Birth")} :
                    </Label>
                    <Input
                      name="date_of_birth"
                      type="date" // ✅ Datepicker
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.date_of_birth || ""}
                      invalid={
                        validation1.touched.date_of_birth &&
                        validation1.errors.date_of_birth
                          ? true
                          : false
                      }
                    />
                    {validation1.touched.date_of_birth &&
                    validation1.errors.date_of_birth ? (
                      <FormFeedback type="invalid">
                        {validation1.errors.date_of_birth}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3 Register-Select2">
                    <Label className="form-label">{props.t('Select tax residency')} :</Label>
                    <Select styles={colourStyles} value={formData4.tax_residency} onChange={(e) => setFormData4({ ...formData4, tax_residency: e })} options={AllCountriesCustomData2} classNamePrefix="select2-selection" />
                    {CustomError4.tax_residency !== '' ? (<FormFeedback type="invalid" style={{ display: 'block' }}>{CustomError4.tax_residency}</FormFeedback>
                    ): null}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3">
                    <Label className="form-label">{props.t('Tax ID')} :</Label>
                    <Input name="tax_id" type="text" placeholder={props.t('Enter Tax ID')}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.tax_id || ""}
                      invalid={
                        validation1.touched.tax_id && validation1.errors.tax_id ? true : false
                      }
                    />
                    {validation1.touched.tax_id && validation1.errors.tax_id ? (
                      <FormFeedback type="invalid">{validation1.errors.tax_id}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3">
                    <Label className="form-label">
                      {props.t("Address")} :
                    </Label>
                    <input
                      type="text"
                      ref={inputRef} // <-- NEW: attach Google Autocomplete
                      name="address"
                      placeholder={props.t("Enter Address")}
                      className={`form-control ${validation1.touched.address && validation1.errors.address ? "is-invalid" : ""}`}
                      onChange={validation1.handleChange} // <-- NEW: update Formik state manually if user types
                      onBlur={validation1.handleBlur} // <-- NEW: validate Formik field
                      value={validation1.values.address} // <-- NEW: show selected value
                    />
                    {validation1.touched.address &&
                      validation1.errors.address && (
                        <FormFeedback type="invalid">
                          {validation1.errors.address}
                        </FormFeedback>
                      )}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3">
                    <Label className="form-label">{props.t('Building')} :</Label>
                    <Input name="building" type="text" placeholder={props.t('Enter Building')}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.building || ""}
                      invalid={
                        validation1.touched.building && validation1.errors.building ? true : false
                      }
                    />
                    {validation1.touched.building && validation1.errors.building ? (
                      <FormFeedback type="invalid">{validation1.errors.building}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3">
                    <Label className="form-label">{props.t('Floor')} :</Label>
                    <Input name="floor" type="text" placeholder={props.t('Enter Floor')}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.floor || ""}
                      invalid={
                        validation1.touched.floor && validation1.errors.floor ? true : false
                      }
                    />
                    {validation1.touched.floor && validation1.errors.floor ? (
                      <FormFeedback type="invalid">{validation1.errors.floor}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md="6" xs="12">
                  <div className="mb-3">
                    <Label className="form-label">{props.t('Zip Address')} :</Label>
                    <Input name="zip" type="text" placeholder={props.t('Enter Zip Address')}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.zip || ""}
                      invalid={
                        validation1.touched.zip && validation1.errors.zip ? true : false
                      }
                    />
                    {validation1.touched.zip && validation1.errors.zip ? (
                      <FormFeedback type="invalid">{validation1.errors.zip}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                 
                <div className="text-left mt-2">
                  <button type="button" 
                    id="submit1"
                    onClick={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                    }}
                  className="btn btn-primary me-2">Update</button>
                  <Link to="/user_management" className="btn btn-light me-2">Cancel</Link>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Edit_user);
